/** target の上端を scrollContainer の可視領域の上端に合わせる scrollTop を返す */
export function computeScrollTopToAlignElementTop(
  scrollContainer: HTMLElement,
  target: HTMLElement,
): number {
  return (
    target.getBoundingClientRect().top -
    scrollContainer.getBoundingClientRect().top +
    scrollContainer.scrollTop
  );
}
